// Founder 2026-09-27: "אשמח לדבר עם שמאי מקרקעין" for categories that name a professional (a WHO), and
// "עם מומחה לסגירת מרפסת זכוכית" only for categories that name a service/product (a WHAT).
// Every category name whose first word is one of SERVICE_WORDS is a WHAT; everything else (שמאי, יועץ, טכנאי, חברת…) is a WHO.
// Mirror of the list in scripts/wa-worker.mjs (expertPhrase) — keep both in sync.
export const SERVICE_WORDS = ['סגירת', 'בניית', 'התקנת', 'תיקון', 'דלתות', 'ביטוח', 'בדיקות', 'דיטיילינג', 'מיטרנט', 'שיפוץ', 'ניקוי', 'הובלות', 'פינוי'];
export function isServiceCategory(name?: string | null): boolean {
  const w = String(name || '').trim().split(/\s+/)[0] || '';
  return SERVICE_WORDS.includes(w);
}
/** "שמאי מקרקעין" | "מומחה לסגירת מרפסת זכוכית" — the noun phrase for the expert of this category. */
export function expertPhrase(name?: string | null): string {
  const n = String(name || '').trim();
  if (!n) return 'מומחה';
  return isServiceCategory(n) ? `מומחה ל${n}` : n;
}
